import { Instance, types } from 'mobx-state-tree';
import Common from '@store/common';
import GenericSpei from '@store/genericSpei';

const ArcusStore = types.compose(Common, types.model({}), GenericSpei);

export type IArcusStore = Instance<typeof ArcusStore>;
export default ArcusStore;
